export const QUIL_MODULES = {
    toolbar: {
        container: [
            [{font: []}],
            [{header: [1, 2, 3, 4, 5, 6, false]}],
            [{color: []}, {background: []}],
            [{align: []}],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{list: 'ordered'}, {list: 'bullet'}, {indent: '-1'}, {indent: '+1'}],
            ['link', 'image', 'video'],
            ['clean'],
        ],
    },
    imageResize: {
        handleStyles: {
            width: '10px',
            height: '10px',
            backgroundColor: '#6185A6',
            borderRadius: '50%',
        },
    },
    clipboard: {
        matchVisual: false,
    },
};
